module.exports = __webpack_public_path__ + "img/food_pack.84ca90ed.png";